import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomTable from './useCustomTable';
import Table from './Table';
import { Tendency, TendencyPts } from '../Tendency';
import { CellTwoLines } from './CellTwoLines';
import { formatDate, formatNumber, formatPercent } from '../Format';
import Pagination from './Pagination';

const DevicesCell = ({devices, refDevices}) => {
  return (<CellTwoLines
    text={formatNumber(devices)}
    subtext={
      <Tendency
        value={devices}
        refValue={refDevices}/>
    }/>)
}
const OptInRateCell = ({val, refVal}) => {
  return (<CellTwoLines
    text={ formatPercent(val) }
    subtext={
      <TendencyPts value={val} refValue={refVal}/>
    }/>)
}

const DailyDataTable = ({data_by_day}) => {
  const { t } = useTranslation();
  const {
    tableProps,
    paginationProps,
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {date: 'desc'}
  });
  const tableData = useMemo(()=>{
    return data_by_day.map((row) => {
      return {
        ...row,
        new_devices: row.devices - row.prev_devices,
        prev_new_devices: row.prev_devices - row.bef_prev_devices,
        opt_in: row.location_authorized_devices/row.active_devices,
        prev_opt_in: row.prev_location_authorized_devices/row.prev_active_devices,
        loc_consent_rate: row.loc_consented_devices/row.location_authorized_devices,
        prev_loc_consent_rate: row.prev_loc_consented_devices/row.prev_location_authorized_devices,

      }
    })
  }, [data_by_day])

  const columns = useMemo(() => [
    {
      Header: 'Date',
      Cell: ({row}) => (formatDate(row.original.date)),
      accessor: 'date'
    },{
      Header: t("dataByDay.newDevices"),
      Cell: ({row}) => (<DevicesCell devices={row.original.new_devices} refDevices={row.original.prev_new_devices} />),
      accessor: 'new_devices',
    },{
      Header: t("dataByDay.devices"),
      Cell: ({row}) => (<DevicesCell devices={row.original.active_devices} refDevices={row.original.prev_active_devices} />),
      accessor: 'active_devices',
    },{
      Header: t("dataByDay.geolocatedDevices"),
      Cell: ({row}) => (<DevicesCell devices={row.original.location_authorized_devices} refDevices={row.original.ref_location_authorized_devices} />),
      accessor: 'location_authorized_devices',
    },{
      Header: t("dataByDay.optIn"),
      Cell: ({row}) => (<OptInRateCell val={row.original.opt_in} refVal={row.original.prev_opt_in} />),
      accessor: 'opt_in',
    },{
      Header: t("stats.consent"),
      Cell: ({row}) => (<DevicesCell devices={row.original.loc_consented_devices} refDevices={row.original.ref_loc_consented_devices} />),
      accessor: 'loc_consented_devices',
    },{
      Header: t("stats.consent_rate"),
      Cell: ({row}) => (
          <OptInRateCell val={row.original.loc_consent_rate} refVal={row.original.ref_loc_consent_rate} />
        ),
      accessor: 'loc_consent_rate',
    },{
      Header: t("publisher.app.locations"),
      Cell: ({row}) => (<DevicesCell devices={row.original.locations} refDevices={row.original.prev_locations} />),
      accessor: 'locations',
    },{
      Header: t("publisher.app.locations_uu"),
      Cell: ({row}) => (<DevicesCell devices={row.original.locations_uu} refDevices={row.original.prev_locations_uu} />),
      accessor: 'locations_uu',
    },{
      Header: t("publisher.app.locations_uu_30_days"),
      Cell: ({row}) => (<DevicesCell devices={row.original.locations_uu_30_days} refDevices={row.original.prev_locations_uu_30_days} />),
      accessor: 'locations_uu_30_days',
    },
  ]);

  return(<>
    <Table data={tableData} columns={columns} {...tableProps} />
    <Pagination {...paginationProps}/>
  </>)
}

export default DailyDataTable
